import React from 'react'
import { useExportHTL2026Point, useGetHTL2026Points } from '../../api/point'
import { PointPanelScreen } from '../shared/PointPanelScreen'
import { LUBRICANT } from '../../constant/htg-companies'

export const HTL2026Points = () => {
  const columns = [
    { id: 'companyAccountId', label: 'Company Id' },
    { id: 'companyName', label: 'Company Name' },
    { id: 'point', label: 'Total Points' },
    { id: 'salesId', label: 'Sales Id' }
  ]

  return (
    <PointPanelScreen
      title='HTL 2026 Trip Point'
      htgCompany={LUBRICANT}
      useExportApi={useExportHTL2026Point}
      useGetPoints={useGetHTL2026Points}
      columns={columns}
      linkBase='htl-2026-summary'
    />
  )
}
